module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-MediumItalic-5bf73ffaf8c3dabd352030f52781800d.ttf";